/**
 * Created by mac on 12/11/20
 */

const Unit = function (options) {
    this.load(options);

    this.__instanceId = classManager.getNewInstanceId();

    if (!Merge2.current.families[this.code]) {
        cleverapps.throwAsync(`Unit from other world - ${this.getKey()}`);
    }
};

Unit.prototype.destructor = function () {
    this.components.forEach((component) => {
        component.destructor && component.destructor();
    });

    this.removeView();
};

Unit.prototype.setView = function (view) {
    this.view = view;
};

Unit.prototype.removeView = function () {
    if (this.view) {
        this.view.removeAdditionalViews();
        this.view = undefined;
    }

    this.components.forEach((component) => {
        component.removeView();
    });
};

Unit.prototype.onGetView = function () {
    return this.view;
};

Unit.prototype.onAdd = function () {
    if (this.view) {
        this.view.playAddAnimation();
    }
};

Unit.prototype.onDestruction = function (silent) {
    if (this.view) {
        this.view.playDestruction(silent);
    }
};

Unit.prototype.onRemove = function () {
    if (this.view) {
        this.view.onRemove();
    }
};

Unit.prototype.onMove = function (options) {
    if (this.view) {
        this.view.move(options);
    }
};

Unit.prototype.onSqueeze = function () {
    if (this.view) {
        this.view.squeeze();
    }
};

Unit.prototype.onSpawned = function (parentUnit, id, options) {
    options = options || {};

    cleverapps.tutorial.trigger("onUnitSpawned", this);

    if (this.view) {
        this.view.spawn(parentUnit, id, options);
    } else if (options.callback) {
        options.callback();
    }
};

Unit.prototype.onUpdateCustomerMark = function () {
    if (this.view) {
        this.view.updateCustomerMark();
    }
};

Unit.prototype.onShowMissionMark = function (mission) {
    if (this.view) {
        this.view.showMissionMark(mission);
    }
};

Unit.prototype.onShowFresh = function () {
    if (this.view) {
        this.view.showFreshAnimation();
    }
};

Unit.prototype.getResource = function () {
    return Families[this.code].resource;
};

Unit.prototype.getType = function () {
    return Families[this.code].type;
};

Unit.prototype.getData = function () {
    return Families[this.code].units[this.stage];
};

Unit.prototype.load = function (stored) {
    this.code = stored.code;
    this.stage = stored.stage;

    if (typeof this.code !== "string" || !Families[this.code] || !Families[this.code].units[this.stage]) {
        throw `creating unknown unit ${this.code} ${this.stage}`;
    }

    if (stored._data) {
        this._data = stored._data;
    }

    this.components = [];
    ComponentsFactory(this.components, this, stored);
};

Unit.prototype.getInfo = function () {
    const data = {
        stage: this.stage,
        code: this.code
    };

    this.components.forEach((component) => {
        if (component.save) {
            component.save(data);
        }
    });

    if (this._data) {
        data._data = this._data;
    }

    return data;
};

Unit.prototype.save = function () {
    if (!Merge2.current.families[this.code]) {
        cleverapps.throwAsync(`Save unit to other world - ${Unit.GetKey(this)}`);
        return;
    }
    Merge2.current.field.saveUnit(this);
};

Unit.prototype.getKey = function () {
    return Unit.GetKey(this);
};

Unit.prototype.findComponent = function (Component) {
    for (let i = 0; i < this.components.length; i++) {
        if (this.components[i] instanceof Component) {
            return this.components[i];
        }
    }
};

Unit.prototype.setCustomerMark = function (customerMark) {
    if (!!customerMark === !!this.customerMark) {
        return;
    }

    this.customerMark = customerMark;

    this.onUpdateCustomerMark();
};

Unit.prototype.isGrounded = function () {
    return this.findComponent(Grounded) !== undefined;
};

Unit.prototype.isInFog = function () {
    const grounded = this.findComponent(Grounded);
    return grounded && grounded.state === Grounded.STATE.FOG;
};

Unit.prototype.isBooster = function () {
    return Unit.isBooster(this.code);
};

Unit.prototype.isSellable = function () {
    return !this.isBooster() && !["generator", "valuables", "energycup", "chooseline", "thirdelement"].includes(this.getType()) && !this.isGrounded();
};

Unit.prototype.isMovable = function () {
    if (cleverapps.config.editorMode || cleverapps.config.demoMode) {
        return true;
    }

    const data = this.getData();

    if (this.movable === false || data.movable === false) {
        return false;
    }

    for (let i = 0; i < this.components.length; i++) {
        const component = this.components[i];
        if (!component.isMovable()) {
            return false;
        }
    }

    return true;
};

Unit.prototype.canMoveTo = function (x, y) {
    if (!Merge2.current.field.isValid(x, y)) {
        return false;
    }

    if (cleverapps.tutorial.isActive() && !cleverapps.tutorial.checkConditions({ cell: cc.p(x, y) })) {
        return false;
    }

    const unit = Merge2.current.field.getUnit(x, y);
    if (unit && !unit.isMovable()) {
        return false;
    }

    return true;
};

Unit.prototype.handleClick = function () {
    cleverapps.userStatus.reportUserAction();

    if (Merge2.current.field.getUnit(this.x, this.y) !== this) {
        return false;
    }

    if (this.getData().clickable === false) {
        return false;
    }

    if (this.isBlocked()) {
        return false;
    }

    if (this.isInFog()) {
        const fieldReward = this.findComponent(FieldReward);
        if (fieldReward && fieldReward.handleClick()) {
            return true;
        }

        Merge2.current.showHint(this.onGetView(), Messages.get("FogBlockedGround.clickMessage"));

        return false;
    }

    Merge2.current.field.selectUnit(this);

    for (let i = 0; i < this.components.length; i++) {
        const component = this.components[i];

        if (component.handleClick && component.handleClick()) {
            Field.mapEvent(Field.CLICK_UNIT, { affected: this });
            return true;
        }
    }

    return false;
};

Unit.prototype.distanceTo = function (target) {
    return Math.abs(this.x - target.x) + Math.abs(this.y - target.y);
};

Unit.prototype.isMergeable = function (otherUnit) {
    if (this === otherUnit) {
        return false;
    }

    if (cleverapps.tutorial.isActive() && !cleverapps.tutorial.checkConditions({ unit: this, mergeUnit: otherUnit })) {
        return false;
    }

    for (let i = 0; i < this.components.length; i++) {
        const component = this.components[i];
        if (!component.isMergeable(otherUnit)) {
            return false;
        }
    }

    return true;
};

Unit.prototype.setPosition = function (x, y) {
    if (!this.isLifted()) {
        if (cleverapps.config.debugMode) {
            console.log(this);
            throw "setPosition for already positioned unit";
        }
    }

    this.x = x;
    this.y = y;

    const wasUnit = Merge2.current.field.getUnit(this.x, this.y);
    if (wasUnit) {
        wasUnit.remove();
        cleverapps.throwAsync(`Can't find empty slot for ${this.code} ${this.stage} on set position ${x}, ${y}`);
    }

    Merge2.current.field.addUnit(this.x, this.y, this);

    this.save();
};

Unit.prototype.isLifted = function () {
    return this.x === undefined || this.y === undefined;
};

Unit.prototype.isDragged = function () {
    return this.dragX !== undefined || this.dragY !== undefined;
};

Unit.prototype.remove = function (silent) {
    if (!this.isLifted()) {
        const mapUnit = Merge2.current.field.getUnit(this.x, this.y);

        if (!mapUnit || mapUnit !== this) {
            if (cleverapps.config.debugMode) {
                console.log(this, mapUnit);
                throw "Cant be! ";
            }
        }

        Merge2.current.field.removeUnit(this.x, this.y);
        Merge2.current.field.eraseUnit(this);
    }

    for (let i = 0; i < this.components.length; i++) {
        const component = this.components[i];
        component.handleRemove && component.handleRemove();
    }

    if (!silent) {
        this.onRemove();
    }

    Merge2.current.field.onUnitRemoved(this);

    this.destructor();
};

Unit.prototype.sell = function () {
    const price = Unit.CalcSellPrice(this);
    if (price) {
        Merge2.current.addReward(Unit.CalcSellCurrency(this), price, this.onGetView(), {
            withoutDelta: true
        });
        cleverapps.metrics.logEvent(cleverapps.EVENTS.UNITS_SOLD, { value: price });
    }

    Merge2.current.field.rememberRemoved(this);

    this.onDestruction();
    this.remove(true);
};

Unit.prototype.liftUnitFromMap = function () {
    if (this.isLifted()) {
        cleverapps.throwAsync(`lift unit twice ${this.code} ${this.stage}`);
        return;
    }

    Merge2.current.field.eraseUnit(this);

    const map = Merge2.current.field;

    const x = this.x;
    const y = this.y;

    const unit = map.getUnit(x, y);
    if (unit !== this) {
        cleverapps.throwAsync(`can't lift unit that is not from map ${this.code} ${this.stage} ${x} ${y}`);
        return;
    }

    delete unit.x;
    delete unit.y;

    map.removeUnit(x, y);
};

Unit.prototype.handleDragStart = function () {
    cleverapps.userStatus.reportUserAction();

    if (Merge2.current.field.getUnit(this.x, this.y) !== this) {
        return false;
    }

    if (this.isBlocked() || !this.isMovable()) {
        return false;
    }

    Merge2.current.field.selectUnit(this, true);

    this.dragX = this.x;
    this.dragY = this.y;

    this.rawDragX = this.x;
    this.rawDragY = this.y;

    Merge2.current.field.setDragging(this);

    this.components.forEach((component) => {
        if (component.handleDragStart) {
            component.handleDragStart();
        }
    });

    return true;
};

Unit.prototype.handleDragMove = function (rawX, rawY) {
    const x = Math.round(rawX), y = Math.round(rawY);

    this.rawDragX = rawX;
    this.rawDragY = rawY;

    this.dragX = x;
    this.dragY = y;

    let handled = false;

    this.components.forEach((component) => {
        if (component.handleDragMove) {
            handled = component.handleDragMove(rawX, rawY, handled) || handled;
        }
    });
};

Unit.prototype.resetDrag = function () {
    this.dragX = undefined;
    this.dragY = undefined;

    this.rawDragX = undefined;
    this.rawDragY = undefined;

    this.onMove();
};

Unit.prototype.handleDragEnd = function (cancelled) {
    cleverapps.userStatus.reportUserAction();
    cleverapps.centerHint.finishCenterHint();

    if (this.components.some((component) => component.handleDragEnd
        && component.handleDragEnd(this.rawDragX, this.rawDragY, cancelled))) {
        return;
    }

    if (cancelled || this.x === this.dragX && this.y === this.dragY || !this.canMoveTo(this.dragX, this.dragY)) {
        this.resetDrag();

        if (!cancelled) {
            Merge2.current.field.selectUnit(this);
        }
        return;
    }

    this.move(this.dragX, this.dragY, true);

    this.dragX = undefined;
    this.dragY = undefined;

    this.rawDragX = undefined;
    this.rawDragY = undefined;

    Merge2.current.field.selectUnit(this);
};

Unit.prototype.getCreatePrize = function () {
    return this.getData().createPrize;
};

Unit.prototype.move = function (x, y, isNewPlace) {
    const map = Merge2.current.field;

    const occupiedList = [];

    const occupied = map.getUnit(x, y);
    if (occupied && occupied !== this) {
        occupiedList.push(occupied);
    }

    if (!this.isLifted()) {
        this.liftUnitFromMap();
    }

    occupiedList.forEach((occupied) => {
        occupied.liftUnitFromMap();
    });

    this.setPosition(x, y);
    this.onMove({
        isNewPlace
    });

    occupiedList.forEach((occupied) => {
        const empty = map.findEmptySlot(x, y, occupied);
        if (!empty) {
            occupied.remove();
            cleverapps.throwAsync(`Can't find empty slot for ${occupied.code} ${occupied.stage} on move to ${x}, ${y}`);
        } else {
            occupied.setPosition(empty.x, empty.y);
            occupied.onMove({
                isPushed: true
            });
        }
    });
};

Unit.prototype.getFamily = function () {
    return Families[this.code];
};

Unit.prototype.isLast = function () {
    const lastStage = this.getFamily().units.length - 1;
    return lastStage === this.stage;
};

Unit.prototype.squeeze = function () {
    if (this.getData().squeezable !== false) {
        this.onSqueeze();
    }
};

Unit.prototype.clearAnimations = function () {
    this.components.forEach((component) => {
        if (component.clearAnimations) {
            component.clearAnimations();
        }
    });
};

Unit.prototype.setBlock = function (blocked) {
    this.blocked = Boolean(blocked);
};

Unit.prototype.isBlocked = function () {
    if (this.blocked) {
        return true;
    }

    if (cleverapps.tutorial.isActive()) {
        if (!cleverapps.tutorial.checkConditions({ unit: this })) {
            return true;
        }
    }

    return false;
};

Unit.prototype.canSmile = function () {
    if (this.isDragged()) {
        return false;
    }

    if (this.isGrounded()) {
        return this.findComponent(Grounded).canSmile();
    }

    const unitView = this.onGetView();
    if (!unitView) {
        return false;
    }

    return unitView.canSmile();
};

Unit.prototype.smile = function () {
    if (this.isGrounded()) {
        this.findComponent(Grounded).smile();
    } else if (this.view) {
        this.view.smile();
    }
};

Unit.isSideQuest = function (code) {
    if (!Families[code]) {
        cleverapps.throwAsync(`No family for code ${code}`);
        return;
    }
    return Families[code].sideQuest;
};

Unit.isBooster = function (code) {
    return Boolean(Families[code] && Families[code].booster);
};

Unit.Equals = function (unit1, unit2) {
    return unit1 && unit2 && unit1.code !== undefined && unit1.stage !== undefined
        && unit1.code === unit2.code && unit1.stage === unit2.stage;
};

Unit.CalcSellCurrency = function () {
    return "orderStar";
};

Unit.CalcSellPrice = function (unit) {
    const price = (unit.stage) * Math.sqrt(unit.stage);
    return Math.floor(price / 5);
};

Unit.CalcSpeedUPPrice = function (duration) {
    const energyCost = 2;
    return Math.ceil((duration / 60 / 1000) * energyCost);
};

Unit.CalcCupStars = function (unit) {
    let amount = unit.stage;

    if (unit.stage >= 3) {
        amount = Math.floor(Math.pow(2.1, unit.stage - 3)) * 10;
    }

    return amount;
};

Unit.IsApplicable = function (target, unit) {
    if (Array.isArray(target)) {
        return unit && target.some((targetItem) => Unit.IsApplicable(targetItem, unit));
    }

    const type = unit.getType ? unit.getType() : unit.type;

    return !target || (target.type === undefined || target.type === type)
        && (target.code === undefined || target.code === unit.code)
        && (target.stage === undefined || target.stage === unit.stage);
};

Unit.GetKey = function (unit) {
    return `${unit.code}_${unit.stage}`;
};

Unit.GetPositionKey = function (unit) {
    return `${unit.x}_${unit.y}`;
};

Unit.ParseKey = function (key) {
    key = key.split("_");

    if (key.length !== 2) {
        return;
    }

    return {
        code: key[0],
        stage: cleverapps.castType(key[1])
    };
};

Unit.ParsePositionKey = function (key) {
    key = key.split("_");
    return {
        x: parseInt(key[0]),
        y: parseInt(key[1])
    };
};

Unit.DISABLED_CODES = cleverapps.createSet(["thirdelement"]);

Unit.MINIMAL_SELL_LEVEL = 6;
